'use strict';

var _ = require('lodash');
var MarketShareFactory = function MarketShareFactory() {
  function MarketShare(shares) {
    this.data = [{
      dayOfWeek: 'Monday',
      share: ''
    }, {
      dayOfWeek: 'Tuesday',
      share: ''
    }, {
      dayOfWeek: 'Wednesday',
      share: ''
    }, {
      dayOfWeek: 'Thursday',
      share: ''
    }, {
      dayOfWeek: 'Friday',
      share: ''
    }, {
      dayOfWeek: 'Saturday',
      share: ''
    }, {
      dayOfWeek: 'Sunday',
      share: ''
    }];
    var groupedShares = _.groupBy(shares, 'dayOfWeek');
    _.forEach(this.data, function (day) {
      if (groupedShares[day.dayOfWeek]) {
        day.share = groupedShares[day.dayOfWeek][0].hostShare;
        day.hostShare = groupedShares[day.dayOfWeek][0].hostShare;
        day.origin = groupedShares[day.dayOfWeek][0].origin;
        day.destination = groupedShares[day.dayOfWeek][0].destination;
        day.significantPOS = groupedShares[day.dayOfWeek][0].significantPOS;
        day.hepKey = groupedShares[day.dayOfWeek][0].hepKey;
      }
    });
  }
  MarketShare.prototype.isValid = function () {
    return true;
  };
  return MarketShare;
};
MarketShareFactory.$inject = [];
module.exports = MarketShareFactory;